import { SLAViewDto } from '@issuemanager/api-client';
import { isAfterDate } from '@issuemanager/apps/client/utils';
import { MAX_DATE_PICKER_DATE } from '@issuemanager/constants';
import dayjs from 'dayjs';

export function getSLAMaxDateTime(
  SLAs: SLAViewDto[],
  severity: string | undefined,
  issueCreatedAt?: string,
): Date | undefined {
  if (!severity || SLAs.length === 0) return undefined;

  const selectedSla = SLAs.find((sla) => sla.severity === severity);
  if (!selectedSla) return undefined;

  const maxSlaDate = dayjs(issueCreatedAt ?? Date.now()).add(
    selectedSla.maxDueDate,
    'day',
  );

  if (maxSlaDate.toDate() > MAX_DATE_PICKER_DATE) return MAX_DATE_PICKER_DATE;

  if (maxSlaDate.isBefore(dayjs()) || maxSlaDate.isSame(dayjs(), 'day')) {
    return undefined;
  }

  return maxSlaDate.toDate();
}

export function isDateEarlierThanSLA(
  SLAs: SLAViewDto[],
  severity: string | undefined,
  value: Date | undefined,
  issueCreatedAt?: string,
  slaEnabled = false,
): boolean {
  if (!slaEnabled) {
    return true;
  }

  if (!severity || !value) return true;

  const selectedSla = SLAs.find((sla) => sla.severity === severity);
  if (!selectedSla) return true;

  const maxDueDate = getSLAMaxDateTime(SLAs, severity, issueCreatedAt);
  if (!maxDueDate) return true;

  return !isAfterDate(value, maxDueDate);
}
